// extracted by mini-css-extract-plugin
export default {"title":"about-page-title-bXCgxa"};